module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-120.cb7223fc.jpg";